import { Box, Button, Card, Dialog, DialogActions, Grid, Typography, alpha, styled, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { fCurrency } from '../../utils/formatNumber';
import { calculatePercentageVariation } from '../../utils/percentageVariations';
import ReactApexChart from 'react-apexcharts';

const CardDashboardDialog = ({
  title = 'title',
  data = [],
  children,
  productosPorQuincena = [],
  dataGraficas = [],
  utilidades,
  parent
}) => {
  const [open, setOpen] = useState(false);
  const [percentage, setPercentage] = useState();
  const labels = Object.keys(productosPorQuincena);
  const theme = useTheme();

  function formatDateLabel(dateStr) {
    const [, month, quincena] = dateStr.split('-');
    const monthNames = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    const quincenaStr = quincena === '1' ? '1era' : '2da';
    return `${monthNames[parseInt(month, 10)]}/ ${quincenaStr}`;
  }
  const formattedLabels = labels.slice(0, 6).reverse().map(formatDateLabel);
  const dataGr = formattedLabels.map((label, index) => ({
    x: label,
    y: utilidades[index]
  }));

  const CHART_DATA = [{ data: dataGr.slice(0, 6).reverse() }];

  const chartOptions = {
    series: [{ data: utilidades.slice(0, 6) }],
    chart: {
      height: 350,
      type: 'bar',
      events: {
        click(chart, w, e) {
          // console.log(chart, w, e)
        }
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '75%',
        distributed: true
      }
    },
    colors: [theme.palette.primary.main],
    dataLabels: {
      enabled: true,
      formatter: (value) => parseFloat(value).toFixed(2)
    },
    legend: {
      show: false
    },
    xaxis: {
      categories: formattedLabels,
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        formatter: (value) => parseFloat(value).toFixed(2)
      }
    }
  };

  useEffect(() => {
    const percentageVariations = calculatePercentageVariation(dataGraficas);
    setPercentage(percentageVariations[0]);
  }, [dataGraficas]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Card sx={{ padding: 2, width: '100%', minHeight: '300px' }}>
      <Grid container sx={{ height: '100%' }} spacing={2}>
        <Grid item xs={5} sx={{ height: '100%' }}>
          <Card sx={{ height: '100%', padding: 3, justifyContent: 'center', alignItems: 'center' }}>
            {dataGraficas.length > 0 ? (
              <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} width="100%" height={200} />
            ) : (
              <Typography variant="h4">No hay datos que mostrar por el momento</Typography>
            )}
          </Card>
        </Grid>
        <Grid item xs={7} sx={{ display: 'flex' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card
                sx={{
                  padding: 1,
                  height: '100%',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center'
                }}
                onClick={handleClickOpen}
              >
                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  <Typography variant="h4">Ver {title} totales</Typography>
                  <Typography variant="h2" color="#00086e">
                    {data.length}
                  </Typography>
                </Box>
              </Card>
              <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
                <Box>{children}</Box>
                <DialogActions>
                  <Button onClick={handleClose}>Cerrar</Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <Grid item xs={12}>
              <Card sx={{ height: '100%', padding: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%'
                  }}
                >
                  <Typography variant="h5">Utilidad quincena anterior</Typography>
                  <Typography variant="h3" color="#00086e">
                    {fCurrency(utilidades[1])}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%'
                  }}
                >
                  <Typography variant="h5">Utilidad esta quincena</Typography>
                  <Typography variant="h3" color="#00086e">
                    {fCurrency(utilidades[0])}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CardDashboardDialog;
